export default __webpack_public_path__ + "static/media/marking--discrete--arrow--left.5a8ed6fe.png";